import { createTheme } from '@mui/material/styles';

import breakpoints from 'utils/breakpoints';
import { getColor } from 'utils/colors';
import mixins from 'utils/mixins';
import { remCalc } from 'utils/remCalc';

const theme = createTheme({
	breakpoints: breakpoints,
	mixins: mixins,
});

export const styles = {};

export const overrides = {
	'.pageAttribs': {
		'.pageAttribs__items': {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			flexDirection: 'column',
			gap: remCalc(10),
			paddingTop: remCalc(30),
			paddingLeft: 0,
			paddintRight: 0,
			paddingBottom: remCalc(30),
			marginTop: remCalc(25),
			marginBottom: remCalc(80),
			borderTop: `1px solid ${getColor('ivory', 600)}`,
			borderBottom: `1px solid ${getColor('ivory', 600)}`,
			'--pageAttribs-count': 1,

			'.pageAttribs__item': {
				display: 'flex',
				justifyContent: 'center',
				minWidth: `calc((80% - ${remCalc(60)}) / var(--pageAttribs-count))`,
				maxWidth: `calc((80% - ${remCalc(60)}) / var(--pageAttribs-count))`,
				fontFamily: 'var(--font-brandon-grotesque)',
				fontSize: remCalc(16),
				fontWeight: 420,
				lineHeight: 1.25,
				letterSpacing: 2,
				textTransform: 'uppercase',
				textDecoration: 'none',
				color: getColor('ivory', 600),
				lineBreak: 'anywhere',
				transition: 'all var(--transition-duration) ease-in',
				'&.pageAttribs__item--anchor': {
					minWidth: 'fit-content',
					maxWidth: 'fit-content',
					borderBottom: `1px solid transparent`,
					'&:hover,&:focus-visible': {
						color: getColor('ivory', 700),
						borderBottomColor: getColor('ivory', 700),
					},
				},
				'&.pageAttribs__item--first': {
					justifyContent: 'flex-start',
					[theme.breakpoints.down('md')]: {
						justifyContent: 'center',
					}
				},
				'&.pageAttribs__item--middle': {
					textAlign: 'center',
					justifyContent: 'center',
				},
				'&.pageAttribs__item--last': {
					justifyContent: 'flex-end',
					[theme.breakpoints.down('md')]: {
						justifyContent: 'center',
					}
				},
				'&.pageAttribs__item--single': {
					textAlign: 'center',
					justifyContent: 'center',
				},

				'&:hover': {
					color: getColor('ivory', 600),
					borderBottomColor: 'transparent',
				},
				'&:focus-visible': {
					color: getColor('ivory', 600),
					borderBottomColor: 'transparent',
				},
			},

			'.pageAttribs__item__icon': {
				display: 'inline-flex',
				alignItems: 'center',
				justifyContent: 'center',
				'> svg': {
					width: remCalc(10),
					marginLeft: remCalc(20),
				},
			},

			'.pageAttribs__divide': {
				display: 'block',
				minWidth: remCalc(20),
				borderBottom: `1px solid ${getColor('ivory', 600)}`,
				transition: 'all 0.3s ease',
				transform: 'rotate(-45deg)',
			},

			[theme.breakpoints.up('md')]: {
				marginTop: remCalc(40),
				flexDirection: 'row',
				gap: remCalc(50),
				padding: remCalc(30),
				'&.pageAttribs__items--multiple': {
					justifyContent: 'space-between',
				},
			},

			[theme.breakpoints.down('md')]: {
				'.pageAttribs__item': {
					justifyContent: 'center',
					textAlign: 'center',
					maxWidth: '100%',
					// marginLeft: remCalc(20),
					marginLeft: '0',
				},
				'.pageAttribs__divide': {
					// width: remCalc(20),
					width: '100%',
					transform: 'rotate(0deg)',
					flexBasis: '100%',
					margin: `${remCalc(10)} 0`,
				},
			},
		},
	},
};

export default styles;
